import React from 'react'
import { useTranslation } from 'react-i18next'

export default function FormattedCurrency({value}) {

    const { i18n } = useTranslation()
    const formattedNumber = new Intl.NumberFormat(i18n.language, { maximumFractionDigits: 2 }).format(value).replace(/US/g, "")

    return <span>{ formattedNumber }</span>
}